import _ from 'lodash'
import React, {Component} from 'react'
import autoBind from 'react-autobind'
import {connect} from 'react-redux'
import {withRouter} from 'react-router'
import {bindActionCreators} from 'redux'
import {Container, Image, Segment} from 'semantic-ui-react'

import back from '../../../assets/images/angle-fuchsia.png'
import AssignedExercises from './assigned-exercises'
import CompletedExercises from '../../common/completed-exercises'
import {tr} from '../../../helpers/languages'
import {send} from '../../../helpers/requests'
import OtherExercise from './other-exercise'
import {actions as participants} from '../../../store/actions/participants'

class Exercises extends Component {
    constructor(props) {
        super(props)
        this.state = {
            exercises: [],
            // Allowed values: assigned, completed, other, previous.
            view: this.props.session.status === 'completed' ? 'completed' : 'assigned',
            index: undefined
        }
        autoBind(this)
    }

    componentDidMount() {
        const { userTokens } = this.props

        if (userTokens.accessToken.token) {
            this.ensureAvailableExercisesLoaded()
            this.setAssignedExercises()
        }
    }

    componentWillReceiveProps(nextProps) {
        // Re-fetch if token changes.
        if (nextProps.userTokens.accessToken.token !== this.props.userTokens.accessToken.token) {
            this.ensureAvailableExercisesLoaded()
            this.setAssignedExercises()
        }
    }

    ensureAvailableExercisesLoaded () {
        const participant_a0 = this.props.match.params.id
        const available_exercises = this.props.available_exercises[participant_a0] || []
        console.log("ensureAvailableExercisesLoaded participant_a0: ", participant_a0)
        console.log("ensureAvailableExercisesLoaded this.props.available_exercises: ", this.props.available_exercises)
        console.log("ensureAvailableExercisesLoaded available_exercises: ", available_exercises)
        if (Array.isArray(available_exercises) && available_exercises.length > 0) {
            console.log(`Using cached available exercises for ${participant_a0}`)
            return
        }
        // Fetch the available exercises.
        this.fetchExercises()
    }

    setAssignedExercises() {
        const participant_a0 = this.props.match.params.id
        const available_exercises = this.props.available_exercises[participant_a0] || []
        console.log("setAssignedExercises participant_a0: ", participant_a0)
        console.log("setAssignedExercises this.props.available_exercises: ", this.props.available_exercises)
        console.log("setAssignedExercises available_exercises: ", available_exercises)
        const assigned = available_exercises.map((exercise) => {
            return {
                ...exercise,
                assigned: this.props.session.exercises.some((e) => {
                    return e.id === exercise.id && e.type === 'assigned'
                })
            }
        })
        const custom = this.props.session.exercises.filter((exercise) => {
            return exercise.id.startsWith('custom-')
        })
            .map((exercise) => {
                return {...exercise, assigned: true, custom: true}
            })
        this.setState({exercises: assigned.concat(custom)})
    }

    // Fetches the available exercises.
    fetchExercises() {
        const participant_a0 = this.props.match.params.id
        console.log('Fetch available exercises.')
        send({
            method: 'GET',
            tokens: this.props.userTokens,
            url: `/content/exercises/${participant_a0}`
        })
            .then((response) => {
                // eslint-disable-next-line no-console
                console.log('Fetched available exercises.')
                const data = response.data
                console.log("fetchExercises participant_a0: ", participant_a0)
                console.log("fetchExercises data: ", data)
                this.props.setAvailableExercises({participant_a0, value: data})
            })
            .catch((error) => {
                // Failed to fetch session.
                // eslint-disable-next-line no-console
                console.error('Failed to fetch available exercises.', error)
                // Hide the error.
                this.setState({exercises: []})
            })
    }

    // Changes to the given view.
    changeView(view) {
        if (view === this.state.view) {
            return
        }
        this.setState({view})
    }

    // Deletes the custom exercise at the given index.
    deleteCustomExercise(index) {
        this.setState({
            exercises: this.state.exercises.slice(0, index)
                .concat(this.state.exercises.slice(index + 1))
        }, () => {
            this.changeExercises()
        })
    }

    // Edits the custom exercise at the given index.
    editCustomExercise(index) {
        this.setState({index, view: 'other'})
    }

    // Toggles (assigns or unassigns) the exercise at the given index.
    toggleExercise(index) {
        this.setState({
            exercises: this.state.exercises.map((e, i) => {
                return index === i ? {...e, assigned: !e.assigned} : e
            })
        }, () => {
            this.changeExercises()
        })
    }

    // Changes the exercises.
    changeExercises() {
        let counter = 1
        const exercises = this.state.exercises.filter((e) => {
            return e.assigned
        })
            .map((e) => {
                return _.pick({...e, id: e.custom ? `custom-${counter++}` : e.id}, ['id', 'title', 'description', 'custom_link'])
            })
        this.props.onChangeValue('exercises', exercises)
    }

    // Saves the given custom exercise. If an index is specified, the given custom exercise replaces the exercise at the
    // given index.
    saveCustomExercise(exercise, index) {
        this.setState({
            exercises: index !== undefined ? this.state.exercises.map((e, i) => {
                return index === i ? {
                    ...e,
                    title: exercise.title,
                    description: exercise.description,
                    custom_link: exercise.custom_link
                } : e
            }) : this.state.exercises.concat([{...exercise, assigned: true, custom: true}]),
            index: undefined,
            view: this.props.session.status === 'completed' ? 'completed' : 'assigned'
        }, () => {
            this.changeExercises()
        })
    }

    render() {
        return (
            <Container className='session-exercises'>
                <Segment className='section-title'>
                    {tr('EXERCISES')}
                    {this.props.session.status !== 'completed' &&
                    <span className='for-next-week'>{tr('FOR_NEXT_SESSION')}</span>
                    }
                </Segment>
                {
                    this.state.view === 'assigned' && (
                        <AssignedExercises
                            exercises={this.state.exercises}
                            onAddCustomExercise={(_e) => {
                                this.changeView('other')
                            }}
                            onDeleteCustomExercise={this.deleteCustomExercise}
                            onEditCustomExercise={this.editCustomExercise}
                            onToggleExercise={this.toggleExercise}
                        />
                    )
                }
                {
                    this.state.view === 'previous' && (
                        <div className='l4'>
                            <CompletedExercises
                                exercises={this.props.session.previous_exercises}
                                onClickOnMoodJournals={
                                    () => {
                                        this.props.changeLocation({
                                            section: 'performance',
                                            subsection: 'journals',
                                            module: this.props.session.id,
                                            item: undefined
                                        })
                                    }
                                }
                            />
                        </div>
                    )
                }
                {
                    this.state.view === 'completed' && (
                        <div className='l4 completed'>
                            <CompletedExercises
                                exercises={this.props.session.exercises}
                                onClickOnMoodJournals={
                                    () => {
                                        this.props.changeLocation({
                                            section: 'performance',
                                            subsection: 'journals',
                                            module: this.props.session.id,
                                            item: undefined
                                        })
                                    }
                                }
                            />
                        </div>
                    )
                }
                {
                    this.state.view === 'other' && (
                        <OtherExercise
                            onCancel={
                                () => {
                                    this.changeView(this.props.session.status === 'completed' ? 'completed' : 'assigned')
                                }
                            }
                            onDone={this.saveCustomExercise}
                            exercise={this.state.index === undefined ? undefined : this.state.exercises[this.state.index]}
                            index={this.state.index}
                        />
                    )
                }
                {
                    this.props.session.status !== 'completed' && (
                        <Segment
                            className={this.state.view === 'previous' ? 'next-exercises' : 'previous-exercises'}
                            onClick={(_e) => {
                                this.changeView(this.state.view === 'previous' ? 'assigned' : 'previous')
                            }}
                        >
                            <Image src={back}/>
                            {tr(this.state.view === 'previous' ? 'NEXT_EXERCISES' : 'PREVIOUS_EXERCISES')}
                        </Segment>
                    )
                }
            </Container>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.settings.language,
        userTokens: state.users.userTokens,
        available_exercises: state.participants.available_exercises
    }
}

const mapDispatchToProps = (dispatch) => {
    const _participants = bindActionCreators(participants, dispatch)
    return {
        changeLocation: _participants.changeLocation,
        setAvailableExercises: _participants.setAvailableExercises
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Exercises))



// WEBPACK FOOTER //
// ./src/components/participant-session/exercises/index.js